module.exports = __webpack_public_path__ + "img/profile_whiet.d3b1ec69.svg";